<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { push } from 'svelte-spa-router';
  import { IconArrowLeft } from '@tabler/icons-svelte';

  export let embedded = false;
</script>

{#if !embedded}
  <div class="min-h-screen bg-gradient-to-br from-slate-50 via-purple-50 to-slate-50 dark:from-slate-900 dark:via-purple-900 dark:to-slate-900 flex items-center justify-center p-4 transition-colors duration-300">
    <div class="w-full max-w-4xl">
      <!-- Back Button -->
      <button
        on:click={() => push('/')}
        class="glass-button flex items-center gap-2 px-4 py-2 rounded-lg mb-6 text-slate-900 dark:text-white"
        aria-label="Back to home"
      >
        <IconArrowLeft class="w-5 h-5" />
        <span>{$_('pages.back')}</span>
      </button>

      <!-- Impressum Card -->
      <div class="glass-card p-8 md:p-12 rounded-3xl shadow-2xl">
        <h1 class="text-3xl md:text-4xl font-bold text-custom-heading dark:text-white text-center mb-8">
          {$_(`pages.impressum.title`)}
        </h1>

        <div class="prose prose-slate dark:prose-invert max-w-none text-custom dark:text-white">
          <section class="mb-8">
            <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
              {$_(`pages.impressum.section1.title`)}
            </h2>
            <p class="mb-2 text-custom dark:text-white">
              <strong>{$_(`pages.impressum.company.name`)}</strong><br />
              {$_(`pages.impressum.company.address`)}<br />
              {$_(`pages.impressum.company.city`)}<br />
              {$_(`pages.impressum.company.country`)}
            </p>
            <p class="text-custom dark:text-white">
              {$_(`pages.impressum.company.represented`)}
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
              {$_(`pages.impressum.section2.title`)}
            </h2>
            <p class="mb-2 text-custom dark:text-white">
              <strong>{$_(`pages.impressum.contact.email`)}</strong><br />
              <strong>{$_(`pages.impressum.contact.phone`)}</strong>
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
              {$_(`pages.impressum.section3.title`)}
            </h2>
            <p class="text-custom dark:text-white">
              {$_(`pages.impressum.vat.id`)}
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
              {$_(`pages.impressum.section4.title`)}
            </h2>
            <p class="text-custom dark:text-white">
              {$_(`pages.impressum.responsible.content`)}
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
              {$_(`pages.impressum.section5.title`)}
            </h2>
            <p class="text-custom dark:text-white">
              {$_(`pages.impressum.disclaimer.content`)}
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
              {$_(`pages.impressum.section6.title`)}
            </h2>
            <p class="text-custom dark:text-white">
              {$_(`pages.impressum.eu.content`)}
              <a
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noopener noreferrer"
                class="text-green-600 dark:text-green-400 hover:underline"
              >
                https://ec.europa.eu/consumers/odr
              </a>
              <br />
              {$_(`pages.impressum.eu.notice`)}
            </p>
          </section>

          <section class="text-sm text-custom-secondary dark:text-white/70">
            <p>{$_(`pages.impressum.lastUpdated`)}</p>
          </section>
        </div>
      </div>
    </div>
  </div>
{:else}
  <!-- Impressum Content (embedded, ohne Card) -->
  <div class="p-8 md:p-12">
    <h1 class="text-3xl md:text-4xl font-bold text-custom-heading dark:text-white text-center mb-8">
      {$_(`pages.impressum.title`)}
    </h1>

    <div class="prose prose-slate dark:prose-invert max-w-none text-custom dark:text-white">
      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
          {$_(`pages.impressum.section1.title`)}
        </h2>
        <p class="mb-2 text-custom dark:text-white">
          <strong>{$_(`pages.impressum.company.name`)}</strong><br />
          {$_(`pages.impressum.company.address`)}<br />
          {$_(`pages.impressum.company.city`)}<br />
          {$_(`pages.impressum.company.country`)}
        </p>
        <p class="text-custom dark:text-white">
          {$_(`pages.impressum.company.represented`)}
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
          {$_(`pages.impressum.section2.title`)}
        </h2>
        <p class="mb-2 text-custom dark:text-white">
          <strong>{$_(`pages.impressum.contact.email`)}</strong><br />
          <strong>{$_(`pages.impressum.contact.phone`)}</strong>
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
          {$_(`pages.impressum.section3.title`)}
        </h2>
        <p class="text-custom dark:text-white">
          {$_(`pages.impressum.vat.id`)}
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
          {$_(`pages.impressum.section4.title`)}
        </h2>
        <p class="text-custom dark:text-white">
          {$_(`pages.impressum.responsible.content`)}
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
          {$_(`pages.impressum.section5.title`)}
        </h2>
        <p class="text-custom dark:text-white">
          {$_(`pages.impressum.disclaimer.content`)}
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4 text-custom-heading dark:text-white">
          {$_(`pages.impressum.section6.title`)}
        </h2>
        <p class="text-custom dark:text-white">
          {$_(`pages.impressum.eu.content`)}
          <a
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noopener noreferrer"
            class="text-green-600 dark:text-green-400 hover:underline"
          >
            https://ec.europa.eu/consumers/odr
          </a>
          <br />
          {$_(`pages.impressum.eu.notice`)}
        </p>
      </section>

      <section class="text-sm text-custom-secondary dark:text-white/70">
        <p>{$_(`pages.impressum.lastUpdated`)}</p>
      </section>
    </div>
  </div>
{/if}
